// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton_backBtn__VHr2s","greenBackButton":"BackButton_greenBackButton__A6Lgg"};